import React, { Component } from 'react';
import { connect } from 'react-redux';
import { map, reverse } from 'lodash';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { SubTitle, Point } from './';
import MobileLineItem from './MobileLineItem';

import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';

class BundleItem extends Component {
  constructor() {
  super();
  this.myRef=null
  this.state = {
    programs:[],
    arrStatus: true,
  };

  this.arrClose = this.arrClose.bind(this);
  this.arrOpen = this.arrOpen.bind(this);
  this.scrollToMyRef = this.scrollToMyRef.bind(this);
}
arrClose() {
    this.setState({
        arrStatus: false,
    });
  }
  arrOpen() {
    this.setState({
        arrStatus: true,
    });
  }
scrollToMyRef () {
     window.scrollTo({
         top:this.myRef.offsetTop,
         behavior: "smooth"
     })
 }
  componentDidMount(){
    this.scrollToMyRef()
  }

  setSubTitle(product) {
    if(product.Data.macAddress)
      return product.Data.macAddress;
    if(product.Data.serialNumber)
      return product.Data.serialNumber;
    return product.Data.level;
  }

  setSubscription(product) {
    if(product.Data.macAddress)
      return 'MAC';
    if(product.Data.serialNumber)
      return this.props.translate('serial-number');
    return this.props.translate('user-level');
  }

  render() {
    const { translate, isActive, userProductId, title, subscription1, subtitle1, subscription2, subtitle2,  isFrozen, userProducts} = this.props
    const userProductsRep =   map(userProducts, (product) => {

      let title;
      let subscription1;
      let subtitle1;
      let subscription2;
      let subtitle2;
      if (product.Data.category === 'MOBILE') {
        title = PhoneNumberFormat(product.Data.phoneNumber)
        subscription1 = translate('current-offer')
        subtitle1 = product.Data.offer
        subscription2=translate('virtual-number')
        subtitle2=PhoneNumberFormat(product.Data.virtualPhoneNumber)
      } else if (product.Data.category === 'FIXE'){
        title = product.Data.offer
        subscription1 = translate('device')
        subtitle1 = product.Data.device
      } else if (product.Data.category === 'INTERNET'){
        title = product.Data.offer
        subscription1= translate('installation-address')
        subtitle1 = product.Data.dataAddress
      } else if (product.Data.category === 'TV'){
        const subTitle = this.setSubTitle(product);
        const subscription = this.setSubscription(product);
        title = product.Data.offer
        subscription1 = subscription
        subtitle1 = subTitle
        subscription2=translate('payment-type')
        subtitle2=product.Data.paymentType
      }
          return (
            <MobileLineItem
              Data={product.Data}
              isFrozen={product.Data.isFrozen}
              hasFutureFreeze={product.Data.hasFutureFreeze}
              futureFreezeStartingDate={product.Data.futureFreezeStartingDate}
              currentFreezeEndDate={product.Data.currentFreezeEndDate}
              forwardData={product.Data.forwardData}
              isActive={product.Data.isActive}
              userProductId={product.Data.userProductId}
              offer={product.Data.offer}
              title={title}
              subscription1={subscription1}
              subtitle1={subtitle1}
              subscription2={subscription2}
              subtitle2={subtitle2}
              createdDate={product.Data.createdDate}
              simNumber={product.Data.simNumber}
              provider={product.Data.provider}
              options={reverse(product.Options)}
              key={product.Data.userProductId}
              showOptions={product.Data.showOptions}
            />
          );


      })
    let active = isActive ? translate("active") : translate("inactive");
    let isActivePoint = isActive ? 'ACTIVE' : 'INACTIVE';
      if (isFrozen) {
        active = "FREEZE"
        isActivePoint = 'FREEZE';
    }
  const collapseStatus = this.state.arrStatus ? <div className="card-footer collapsed" data-toggle="collapse" data-target={`#${userProductId}`}  aria-expanded="true" style={{display:!collapseStatus}} onClick={this.arrClose} >
      <div className="collapse-indicator" >
        {translate('more-information')}
      </div>
      <i className="material-icons arrow-footer" >
        keyboard_arrow_down
      </i>
    </div>
    :
    <div className="card-footer collapsed" data-toggle="collapse" data-target={`#${userProductId}`}  aria-expanded="true" style={{display:!collapseStatus}} onClick={this.arrOpen} >
      <div className="collapse-indicator " >
        {translate('close-information')}
      </div>
      <i className="material-icons arrow-footer" >
        keyboard_arrow_up
      </i>
    </div>;
    return(
      <div className="card card-service card-service-active" id={userProductId}>
        <div className="card-header">
          <h4 className="card-title card-title-bottomline">
            <div className="row">
              <div className="col-12 col-md-8"><span>{title}</span>
              </div>
              <div className="col-md-4 text-md-right" id='MyServices'>
                  {Point(isActivePoint)}
                  <div className="service-status-name">{active}</div>
              </div>
            </div>
          </h4>
          <div className="row">
            <div className="col-md-8">
              <h4 className="service-title"></h4>
            </div>

          </div>
          <div className='row'>
            <div className="col">
              <div className="service-subscription">
                {SubTitle(subscription1, subtitle1)}
                {SubTitle(subscription2, subtitle2)}
                <div ref={ (ref) => this.myRef=ref }></div>
              </div>
            </div>
          </div>
              <div  aria-expanded="true" id={userProductId}>
                    {userProductsRep}
              </div>
        </div>
        <div className="">
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

  BundleItem = connect(
    mapStateToProps,
    mapDispatchToProps
  )(BundleItem);
export default BundleItem;



// WEBPACK FOOTER //
// ./src/components/MyServices/BundleItem.js